/**
 * @file: 办公 图标 SVG
 * 不在图标库
 * book-2-fill
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/13      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
const IconExcel = ({size=14}) => {
    return (
        <img className="iconfont" width={size}
             src={"https://oss.essaone.com/4db256cc-7585-4bea-9814-a4fec165f718.svg"}></img>
    );
}
const IconWord = ({size=14}) => {
    return (
        <img className="iconfont" width={size}
             src={"https://oss.essaone.com/a152dc85-8e6c-465a-8a7c-cccfc610f800.svg"}></img>
    );
}
const IconPDF = ({size=14}) => {
    return (
        <img className="iconfont" width={size}
             src={"https://oss.essaone.com/d0e08dda-d12c-499b-b08a-72e5b504cad1.svg"}></img>
    );
}
const IconVideo = ({size=14}) => {
    return (
        <img className="iconfont" width={size}
             src={"https://oss.essaone.com/532468ff-8da9-4a7a-8e10-ae77492c9a6a.svg"}></img>
    );
}
const IconImage = ({size=14}) => {
    return (
        <img className="iconfont" width={size}
             src={"https://oss.essaone.com/d33d4fc5-ae6d-43fe-aa29-173247da3f0f.svg"}></img>
    );
}
const IconZip = ({size=14}) => {
    return (<img className={"iconfont"} width={size} src={"https://oss.essaone.com/d7410b0c-f852-4be7-b8a1-0f725456ab3f.svg"} />)
}
const IconDefault  = ({size=14}) => {
    return (<img className={"iconfont"} width={size} src={"https://oss.essaone.com/a97a5dd7-3dca-4fbf-8a30-50cf86a58245.svg"} />)
}

export {
    IconExcel,IconWord,IconPDF,IconVideo,IconImage,IconZip,IconDefault
};
